import "@/styles/index.css";

import mobileBar from '@/scripts/components/mobile-bar'
import siteHeader from "@/scripts/components/site-header";
import cursor from "@/scripts/components/cursor";
import button from "@/scripts/components/button";
import sitePreloader from "@/scripts/components/site-preloader";
import scrollReveal from "@/scripts/components/scroll-reveal";
import splitText from "@/scripts/components/split-text";
import smoothScroll from "@/scripts/components/smooth-scroll";
import autoplaySlider from "@/scripts/components/autoplay-slider";
import accordion from "@/scripts/elements/accordion";
import scrollTo from "@/scripts/components/scroll-to";
import pagination from "@/scripts/components/pagination";
import scaleBack from "@/scripts/components/scale-back";
import parallax from "@/scripts/components/parallax";
import form from "@/scripts/components/form/form";
import paginatedList from "@/scripts/components/paginated-list";
import modal from "@/scripts/components/modal";
import sectionReveal from "@/scripts/components/section-reveal";
import overview from "@/scripts/components/overview";
import slideToggle from "@/scripts/components/slide-toggle";
import siteMenu from "@/scripts/components/site-menu";

import Alpine from "alpinejs";
import focus from "@alpinejs/focus";

siteHeader.init();
cursor.init();
mobileBar.init();
button.init();
scrollReveal.init();
scrollTo.init();
form.init();
modal.init();
slideToggle.init();
siteMenu.init();

Alpine.plugin(focus);
Alpine.start();

document.addEventListener('DOMContentLoaded', () => {
  setTimeout(() => {
    document.documentElement.classList.remove('_preload')
  }, 250)

  const setHeights = () => {
    const siteHeader = document.querySelector(".site-header");

    if (siteHeader) {
      document.documentElement.style.setProperty("--site-header-height", `${Math.ceil(siteHeader.offsetHeight)}px`);
    }
  };

  window.addEventListener("resize", setHeights);

  setHeights();
})

const pageHas = (selector) => {
  return document.querySelectorAll(selector).length;
};

const loadComponents = async () => {
  if (pageHas(".preloader")) {
    sitePreloader.init();
  }

  if (pageHas(".split-text")) {
    splitText.init();
  }

  if (pageHas(".splide")) {
    autoplaySlider.init();
  }

  if (pageHas("[data-accordian-trigger]")) {
    accordion.init();
  }

  if (pageHas("[data-pagination-container]")) {
    pagination.init();
  }

  if (pageHas("[data-scale-back]")) {
    scaleBack.init();
  }

  if (pageHas("[data-parallax]")) {
    parallax.init();
  }

  if (pageHas("[data-parallax-group]")) {
    parallax.handleParallaxGroup();
  }

  if (pageHas("[data-image-card-parallax]")) {
    parallax.handleImageCardParallax();
  }

  if (pageHas("[data-paginated-list]")) {
    paginatedList.init();
  }

  if( pageHas("[data-section-reveal]")) {
    sectionReveal.init();
  }

  if (pageHas("[data-overview-media-item]")) {
    overview.init();
  }
};

loadComponents();
